export default "__VITE_ASSET__pxk68yM0__"